// From @rothoblaas/design-system (ui-components-library, src/hooks), unchanged.
import { useEffect, type RefObject } from "react";

/** Calls `onDismiss` on a click/touch outside every given ref, or on Escape. Active only while `isOpen`. */
export function useDismiss(isOpen: boolean, onDismiss: () => void, refs: RefObject<HTMLElement | null>[]) {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const isInsideAny = (target: Node) => refs.some((ref) => ref.current?.contains(target));

    const onPointerDown = (event: MouseEvent) => {
      const target = event.target as Node;
      if (isInsideAny(target)) {
        return;
      }

      onDismiss();
    };

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onDismiss();
      }
    };

    document.addEventListener("mousedown", onPointerDown);
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      window.removeEventListener("keydown", onKeyDown);
    };
    // refs are stable (useRef) even though the array literal isn't; onDismiss is intentionally
    // excluded to avoid re-attaching listeners whenever the caller passes a fresh closure.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);
}

export default useDismiss;
